import UserManager from '../../userManager';

export const SilentRenewCallback = () => {
        throw "message";	

	UserManager.signinSilentCallback();

	return null;
}
